import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-right\"><path fill-rule=\"evenodd\" d=\"M18.69 11.402L7.325 3.04a.211.211 0 00-.212-.022A.189.189 0 007 3.19v1.836c0 .116.058.228.154.299L16.229 12l-9.075 6.675a.37.37 0 00-.154.3v1.835c0 .159.194.247.325.15l11.365-8.362A.744.744 0 0019 12a.744.744 0 00-.31-.598z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol